import React from 'react'

class VersusGames extends React.Component {
  render () {
    return (
      <div>VersusGames</div>
    )
  }
}

export default VersusGames



/** WEBPACK FOOTER **
 ** ./src/components/GameList/VersusGames.js
 **/